<template>
  <v-layout wrap style="font-size: 18px;">
    <v-flex xs12 md10 lg10 offset-md1 offset-lg1>
      <v-toolbar dense extended color="primary" dark title="Administration Area" style="padding-top: 50px">
        <v-flex xs12 pa-5>
          <v-toolbar-title slot="extension" class="display-2">
            <v-icon x-large style="padding-bottom: 10px">settings</v-icon>Administration Area
          </v-toolbar-title>In this area you can add/delete users and edit their personal information, modify access permission for
          users across the system.
        </v-flex>
      </v-toolbar>
      <v-card>
        <v-flex xs12 pa-5>
          <!-- <v-flex xs12 class="padding-10">
            <p class="dislodge_margin">To <b>synchronize data with Aquarius</b>, click the following:</p>
            <v-btn dark color="green accent-4" @click="dialog = true">
              <v-icon left dark>update</v-icon>
              Update stations and datasets from Aquarius
            </v-btn>
          </v-flex>
          <br />-->
          <v-flex xs12 class="padding-10">
            <p class="dislodge_margin">
              To
              <b>manage users/tenants</b>, choose one of the following:
            </p>
            <v-btn dark color="light-blue accent-3" @click="$router.push('/administration/userManage')" :class="{activeLink: $route.fullPath == '/administration/userManage'}">
              <v-icon left dark>account_circle</v-icon>Manage Users
            </v-btn>
            <v-btn dark color="light-blue accent-3" @click="$router.push('/administration/accessManage')" :class="{activeLink: $route.fullPath == '/administration/AdministrationAccessManage'}">
              <v-icon left dark>lock</v-icon>Manage Tenants
            </v-btn>
          </v-flex>
          <br>
          <v-flex xs12 class="padding-10">
            <p class="dislodge_margin">
              To
              <b>manage Media type</b>, click the following:
            </p>
            <v-btn dark color="light-blue accent-3" @click="$router.push('/administration/mediaType')" :class="{activeLink: $route.fullPath == '/administration/mediaType'}">
              <v-icon left dark>dns</v-icon>Manage Media Type
            </v-btn>

            <v-btn dark color="light-blue accent-3" @click="$router.push('/administration/stationCategory')" :class="{activeLink: $route.fullPath == '/administration/stationCategory'}">
              <v-icon left dark>dns</v-icon>Manage Station Category
            </v-btn>

            <v-btn dark color="light-blue accent-3" @click="$router.push('/administration/timeSeriesTag')" :class="{activeLink: $route.fullPath == '/administration/timeSeriesTag'}">
              <v-icon left dark>dns</v-icon>Manage Time Series Tag
            </v-btn>
          </v-flex>
        </v-flex>
      </v-card>
    </v-flex>
    <v-dialog v-model="dialog" max-width="500">
      <v-card>
        <v-card-title class="headline">Update from Aquarius</v-card-title>
        <v-card-text>Update from Aquarius may takes a while, are you sure?</v-card-text>
        <v-progress-linear indeterminate v-if="synchronizing"></v-progress-linear>
        <v-card-text v-html="syncrhonizeMessage"></v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" flat="flat" @click.native="dialog = false">No</v-btn>
          <v-btn color="green darken-1" flat="flat" @click.native="synchronizeAquariusDatabase">Yes</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
  import { createNamespacedHelpers } from 'vuex'
  const admin = createNamespacedHelpers('admin')
  export default {
    data() {
      return {
        dialog: false,
      }
    },
    mounted() {
      this.getUserList()
      this.getRoleList()
    },
    computed: {
      ...admin.mapGetters(['synchronizing', 'syncrhonizeMessage', 'synCompleted']),
    },
    watch: {
      synCompleted() {
        if (this.synCompleted) {
          this.dialog = false
        }
      },
    },
    methods: {
      ...admin.mapActions([
        'getRoleList',
        'getUserList',
        'synchronizeAquariusDatabase',
      ]),
    },
  }
</script>

<style lang="stylus" scoped>
  .toolbar__title.display-2 {
    padding-bottom: 10px;
    margin-left: 10px !important;
  }

  .padding-10 {
    padding: 10px;
  }

  .dislodge_margin {
    margin: 0px;
  }
</style>